import React from "react";
import styles from "./index.module.css";
import { userContext } from "../../Context/user";
import { Routes } from "../../Routes";
import { db } from "../../fire";
import { PrimaryButton } from "../../Components/PrimaryButton";
import { MDBIcon } from "mdbreact";
import { userType } from "../../Constants";

export class Materia extends React.Component {
  state = {
    pile: [],
    service: null,
    isUpdatingServiceOrder: false,
    loadingPile: true,
  };

  componentDidMount() {
    const { authorizationType, subject } = this.props.location.state;

    if (authorizationType === userType.SUPERVISOR) {
      this.getPileForSupervisor(subject);
    } else {
      this.getPileForUser();
    }
  }

  getPileForSupervisor = async (subject) => {
    try {
      const servicesRef = await db
        .collection("pedidosDeServico")
        .where("nomeMateria", "==", subject)
        .get();

      const pile = await Promise.all(
        servicesRef.docs.map(async (doc) => {
          const service = doc.data() || {};

          const objetoRef = await service.objetoRef.get();
          const objetoResultadoRef = await service.objetoResultadoRef.get();

          return {
            id: doc.id,
            ...service,
            objetoRef: objetoRef.data(),
            objetoResultadoRef: objetoResultadoRef.data(),
          };
        })
      );

      this.setState({ pile });
    } catch (error) {
      console.log({ error });
    }
  };

  getPileForUser = async () => {
    const { materia } = this.props.match.params;
    const { authorizationType } = this.props.location.state;
    const { user } = this.context;
    const userPermissons = ["Aberto", "Reprovado", "Aprovado"];

    let userIsAlreadyInAService = false;

    try {
      this.setState({ loadingPile: true });
      const materiasCollection = db.collection("materias");
      const pilesCollectionRef = await materiasCollection
        .where("nome", "==", materia)
        .limit(1)
        .get();

      if (pilesCollectionRef.empty) return;

      const pilesId = pilesCollectionRef.docs[0].id;

      const pileRef = await materiasCollection
        .doc(pilesId)
        .collection("pilhas")
        .get();

      const promises = await Promise.all(
        pileRef.docs
          .map((doc) => doc.data())
          .filter((item) => item.servicoAtivoID)
          .map(async (item) => {
            const serviceRef = await db
              .collection("pedidosDeServico")
              .doc(item.servicoAtivoID)
              .get();

            const service = serviceRef.data() || {};

            if (!userPermissons.includes(service.status)) {
              return;
            }

            if (
              service.status !== "Aberto" &&
              service.prestadorID !== user.id
            ) {
              return;
            }

            if (
              service.prestadorID === user.id &&
              service.status === "Atribuido"
            ) {
              userIsAlreadyInAService = true;
            }

            const objetoRef = await service.objetoRef.get();
            const objetoResultadoRef = await service.objetoResultadoRef.get();

            return {
              id: serviceRef.id,
              ...service,
              objetoRef: {
                id: objetoRef.id,
                ...objetoRef.data(),
              },
              objetoResultadoRef: {
                id: objetoRef.id,
                ...objetoResultadoRef.data(),
              },
            };
          })
          .filter(Boolean)
      );

      const pile = promises
        .filter(Boolean)
        .filter((item) => item.tipo === authorizationType);

      this.setState({ pile, userIsAlreadyInAService });
    } catch (error) {
      console.log({ error });
    }
  };

  setService = (service) => {
    this.setState({ service });
  };

  updateServiceOrder = async () => {
    try {
      const { authorizationType } = this.props.location.state;
      const { service, userIsAlreadyInAService } = this.state;
      const { user } = this.context;

      if (
        service.status === "Aprovado" &&
        authorizationType !== userType.SUPERVISOR
      ) {
        this.props.history.push(Routes.EDITOR, {
          service,
          authorizationType,
          user: this.context?.user,
        });
        return;
      }

      if (
        service.status === "Concluido" &&
        authorizationType !== userType.SUPERVISOR
      ) {
        return;
      }

      if (userIsAlreadyInAService) return;

      this.setState({ isUpdatingServiceOrder: true });

      if (authorizationType === userType.SUPERVISOR) {
        await db.collection("pedidosDeServico").doc(service.id).update({
          supervisorID: user.id,
        });
      } else {
        await db.collection("pedidosDeServico").doc(service.id).update({
          status: "Atribuido",
          prestadorID: user.id,
        });
      }

      this.props.history.push(Routes.EDITOR, {
        service,
        authorizationType,
        user: this.context?.user,
      });
    } catch (error) {}
  };

  render() {
    const { materia } = this.props.match.params;
    const { authorizationType } = this.props.location.state;
    const { pile, service, isUpdatingServiceOrder } = this.state;
    const { user } = this.context;

    return (
      <div className={`container-fluid d-flex`}>
        <div className={styles.table}>
          <h1 className="h6 with-decoration mb-4 text-uppercase">{materia}</h1>

          <table>
            <thead>
              <tr className={styles.head}>
                <th>PILHAS</th>
                <th>STATUS</th>
                <th>USO</th>
                <th>P. SERVIÇO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mb-3">‎</td>
              </tr>
              {pile.map((service, key) => {
                return (
                  <tr className={styles.row} key={key}>
                    <td>
                      {service?.objetoResultadoRef?.codigo.substr(-2) +
                        " - " +
                        service?.objetoResultadoRef?.assunto}
                    </td>
                    <td>{service?.status}</td>
                    <td>{service?.uso}</td>
                    <td>
                      {authorizationType === userType.SUPERVISOR &&
                      service?.status === "Pendente" ? (
                        <button
                          disabled={
                            service.supervisorID &&
                            user.id !== service.supervisorID
                          }
                          onClick={() => {
                            if (
                              service.supervisorID &&
                              user.id !== service.supervisorID
                            ) {
                              return;
                            }
                            this.setService(service);
                          }}
                          className={styles["p-servico"]}
                        >
                          Revisar
                        </button>
                      ) : (
                        <button
                          onClick={() => this.setService(service)}
                          className={styles["p-servico"]}
                        >
                          Ver
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {service && (
          <div className={styles["service-container"]}>
            <h1>Pedido de serviço</h1>
            <p>{service.descricao}</p>
            <PrimaryButton
              size="sm"
              onClick={this.updateServiceOrder}
              className={styles["p-servico"]}
              disabled={isUpdatingServiceOrder}
            >
              COMEÇAR <MDBIcon icon="magic" className="ml-1" />
            </PrimaryButton>
          </div>
        )}
      </div>
    );
  }
}

Materia.contextType = userContext;
